import { useEffect, useState } from 'react';

import { appConfig, loaded } from './appConfig';

/**
 * A React hook that returns the app config from config.json
 * @returns The app config or null if not loaded yet
 */
export function useAppConfig() {
  const [configLoaded, setConfigLoaded] = useState(false);
  useEffect(() => {
    loaded.then(() => setConfigLoaded(true));
  }, []);

  return configLoaded ? appConfig : null;
}
